<template>
  <div>
    <Table :showPages="showPages" :isCustom="isCustom" :title="title" :notExcl="notExcl" :notFilter="notFilter" :customHeaders="customHeaders" :remittance-history="remittanceHistory" :per_page="per_page">
      <template v-slot="{ item }">
        <v-menu v-if="!isCustom" transition="slide-x-transition" bottom right origin="center center">
          <template v-slot:activator="{ on, attrs }">
            <div class="flex items-center">
              <MoreBtn class="mr-2" v-bind="attrs" v-on="on"></MoreBtn>
              <v-tooltip bottom max-width="250">
                <template v-slot:activator="{ on, attrs }">
                  <button
                    v-bind="attrs"
                    v-on="on"
                    class="mr-2 bg-blue-400 w-[26px] h-[26px] flex items-center justify-center flex-shrink-0 rounded-full"
                    color="info"
                    @click="getRemittanceDetail(item.id)"
                  >
                    <v-icon size="17" color="white">mdi-book</v-icon>
                  </button>
                </template>
                <span class="text-[10px]">جزئیات حواله</span>
              </v-tooltip>
            </div>
          </template>
          <v-list>
            <router-link
              :to="{
                name: 'remittanceTracking',
                params: {
                  id: item.remittanceHistory_id,
                },
              }"
            >
              <v-list-item link>
                <v-list-item-title>
                  <span style="font-size: 12px">مسیر طی شده</span>
                </v-list-item-title>
              </v-list-item>
            </router-link>
            <v-list-item link v-if="item.status === 'ARRIVED_TO_SOURCE'" @click="moving(item.id)">
              <v-list-item-title>
                <span style="font-size: 12px">تغییر وضعیت به در حال حمل</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link v-if="item.status === 'MOVING'" @click="arrivedToDestination(item.id)">
              <v-list-item-title>
                <span style="font-size: 12px">تغییر وضعیت به رسیدن به مقصد</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link v-if="item.status === 'ARRIVED_TO_DESTINATION'" @click="delivered(item.id)">
              <v-list-item-title>
                <span style="font-size: 12px">تغییر وضعیت به رسیدن تحویل شده</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="showImage(item.remittanceHistory_id)" v-if="item.path != null">
              <v-list-item-title>
                <span style="font-size: 13px">نمایش عکس بارنامه</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="changePaymentMethod(item.id)" v-if="item.paymentStatus === 'UNPAID'">
              <v-list-item-title>
                <span style="font-size: 13px">تغییر نوع پرداخت</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="paid(item.id)" v-if="item.paymentStatus === 'UNPAID'">
              <v-list-item-title>
                <span style="font-size: 13px">تغییر به پرداخت شده</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="getDriverDetail(item.driver.id)">
              <v-list-item-title>
                <span style="font-size: 12px">اطلاعات راننده</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="printDialog(item)">
              <v-list-item-title>
                <span style="font-size: 12px">پرینت</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="openBoxCancelRemittance(item.id)">
              <v-list-item-title>
                <span style="font-size: 12px">لغو</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="(cancelRemittanceData.turnActive = true), openBoxCancelRemittance(item.id)">
              <v-list-item-title>
                <span style="font-size: 12px">لغو و برگشت نوبت</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <slot v-else :item="item" />
      </template>
    </Table>
    <template v-if="!isCustom">
      <v-dialog v-model="cancelRemittanceData.showBox" max-width="400">
        <v-card>
          <v-toolbar dense flat>
            <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
              لغو حواله جاری
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4 black--text"> آیا میخواهید حواله لغو شود؟ </v-card-text>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="cancelRemittanceData.showBox = false"
              >کنسل</v-btn
            >
            <v-btn
              color="primary"
              class="body-2 font-weight-bold"
              outlined
              @click="cancelRemittance()"
              >تایید</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="remittanceDetailData.showBox" max-width="600">
        <RemittanceDetailBox
          v-if="remittanceDetailData.showBox"
          :is-print="remittanceDetailData.isPrint"
          :remittance-detail="remittanceDetailData.data"
        />
      </v-dialog>
      <v-dialog v-model="showImageData.showBox" max-width="700">
        <v-card>
          <v-toolbar dense flat>
            <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
              نمایش بارنامه
            </v-toolbar-title>
          </v-toolbar>
          <iframe
            v-if="showImageData.isPdf"
            height="700px"
            width="100%"
            :src="showImageData.path"
          ></iframe>
          <v-img
            class="mx-auto"
            height="300"
            lazy-src="https://picsum.photos/id/11/100/60"
            max-width="500"
            :src="showImageData.path"
            v-if="showImageData.isPdf === false"
          >
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="grey-lighten-4"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
          </v-img>
          <div class="flex justify-center my-4">
            <a id="download-link" href="#" download class="hidden">دانلود فایل</a>
            <v-btn color="success" @click="download">دانلود بارنامه</v-btn>
          </div>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="dialogShowImage = false"
              >بستن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="driverData.showBox" width="700px">
        <v-card>
          <div v-if="driverData.data" style="display: flex;flex-direction: column;padding:0 15%" >
            <div class="center" style="margin-top: 30px">
              <span style="font-size: 18px;font-weight: 500;line-height: 28px;text-align: right;color: #6C7F96;">اطلاعات راننده</span>
            </div>
            <div class="center">
              <div style="width: 102px;margin-top: 11px">
                <v-progress-linear value="85"></v-progress-linear>
              </div>
            </div>
            <div class="center" style="margin-top: 40px;flex-direction: column">
              <div class="center">
                <img src="../../assets/driver.jpg" style="width: 100px">
              </div>
              <div class="center" style="margin-top: 16px;display: flex;flex-direction: column;align-items: center">
                <div>
                  <span style="font-size: 28px">{{driverData.data.name + ' ' +driverData.data.family}}</span>
                </div>
                <div>
                  <span>{{driverData.data.user.status === 0 ? 'در حال حاضر غیر فعال است.' : 'در حال حاضر فعال است.'}}</span>
                </div>
              </div>
            </div>
            <div style="margin-top: 30px;">
              <div style="position: relative">
                <img src="../../assets/svg/personal.svg" style="width: 24.17px">
                <span>اطلاعات شخصی </span>
                <v-divider></v-divider>
              </div>
              <div class="spaceBetween marginSpan">
                <div>نام ونام خانوادگی</div>
                <div>
                  <span class="detail">{{driverData.data.name + ' ' + driverData.data.family}}</span>
                </div>
              </div>
              <div class="spaceBetween marginSpan">
                <div>نام پدر</div>
                <div>
                  <span class="detail">{{driverData.data.fatherName}}</span>
                </div>
              </div>
              <div class="spaceBetween marginSpan">
                <div>تاریخ تولد</div>
                <div>
                  <span class="detail">{{driverData.data.birthDate}}</span>
                </div>
              </div>
            </div>
            <div style="margin-top: 30px;">
              <div style="position: relative">
                <img src="../../assets/svg/call.svg" style="width: 24.17px">
                <span>ارتباط</span>
                <v-divider></v-divider>
              </div>
              <div class="spaceBetween marginSpan">
                <div>تلفن منزل</div>
                <div>
                  <span class="detail">{{driverData.data.phone}}</span>
                </div>
              </div>
              <div class="spaceBetween marginSpan">
                <div>تلفن همراه</div>
                <div>
                  <span class="detail">{{driverData.data.mobile}}</span>
                </div>
              </div>
              <div class="spaceBetween marginSpan">
                <div>آدرس</div>
                <div>
                  <span class="detail">{{driverData.data.address}}</span>
                </div>
              </div>
            </div>
            <div style="margin-top: 30px;margin-bottom: 30px">
              <div style="position: relative">
                <img src="../../assets/svg/detail.svg" style="width: 24.17px">
                <span>مشخصلات دیگر</span>
                <v-divider></v-divider>
              </div>
              <div class="spaceBetween marginSpan">
                <div>شارژ ریال</div>
                <div>
                  <span class="detail">{{Seprate(driverData.data.user.wallet)}}</span>
                </div>
              </div>
              <div class="spaceBetween marginSpan">
                <div>شماره بیمه</div>
                <div>
                  <span class="detail">{{driverData.data.insuranceNumber}}</span>
                </div>
              </div>
              <div class="spaceBetween marginSpan">
                <div>تاریخ انقضا کارت سلامت</div>
                <div>
                  <span class="detail">{{driverData.data.health_card_expire_date}}</span>
                </div>
              </div>
              <div class="spaceBetween marginSpan">
                <div>شماره گواهی نامه</div>
                <div>
                  <span class="detail">{{driverData.data.driverLicense}}</span>
                </div>
              </div>
              <div class="spaceBetween marginSpan">
                <div>شماره کارت هوشمند</div>
                <div>
                  <span class="detail">{{driverData.data.smartId}}</span>
                </div>
              </div>
              <div class="spaceBetween marginSpan">
                <div>تاریخ ثبت نام</div>
                <div>
                  <span class="detail">{{driverData.data.created_at}}</span>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </template>
    <slot name="modals" />
  </div>
</template>

<script>
import { convertDateOnly } from "@/plugins/getPersianDate";
import axiosApi from "@/plugins/axios";
import Vue from "vue";
import getPersianDate from "@/plugins/getPersianDate";
import RemittanceDetailBox from "@/components/RemittanceDetailBox.vue";
import Table from "./Table";

export default {
  props: ["remittanceHistory", "title", "notExcl", "showPages", "notFilter", "per_page", "isCustom", "customHeaders"],
  components: { Table, RemittanceDetailBox },
  data() {
    return {
      loading: false,


      showImageData: {
        showBox: false,
        isPdf: false,
        path: "",
      },

      remittanceDetailData: {
        showBox: false,
        isPrint: false,
        data: "",
      },

      driverData: {
        showBox: false,
        data: "",
      },

      cancelRemittanceData: {
        showBox: false,
        remittanceId: '',
        turnActive: false
      },

      

      search: "",
      headersSelected: [
        { text: "شناسه", value: "id" },
        { text: "اعلام بار توسط", value: "type" },
        { text: "وضعیت", value: "status" },
        { text: "نام و فامیل", value: "nameFamily" },
        { text: "کرایه کل به ریال", value: "rent" },
        { text: "کرایه پایه", value: "baseFare" },
        { text: "بیمه", value: "bime" },
        { text: "عوارض", value: "avarez" },
        { text: "کمیسیون شرکت", value: "commission" },
        { text: "شماره ملی", value: "driver.nationalId" },
        { text: "تاریخ", value: "created_at" },
        { text: "پلاک", value: "plaque" },
        { text: "نوع ماشین", value: "carTypeTitle" },
        { text: "نام شرکت", value: "company.company_name" },
        { text: "عملیات", value: "operations" },
      ],
      headers: [
        { text: "شناسه", value: "id", status: true },
        { text: "وضعیت", value: "status", status: true },
        { text: "نام و فامیل", value: "nameFamily", status: true },
        { text: "کرایه کل به ریال", value: "rent", status: true },
        { text: "کرایه پایه", value: "baseFare", status: true },
        { text: "بیمه", value: "bime", status: true },
        { text: "عوارض", value: "avarez", status: true },
        { text: "کمیسیون شرکت", value: "commission", status: true },
        { text: "شماره ملی", value: "driver.nationalId", status: true },
        { text: "تاریخ", value: "created_at", status: true },
        { text: "پلاک", value: "plaque", status: true },
        { text: "نوع ماشین", value: "carTypeTitle", status: true },
        { text: "نام شرکت", value: "company.company_name", status: true },
        { text: "عملیات", value: "operations", status: true },
      ],
      columns: [
        { label: "شناسه", field: "id" },
        { label: "وضعیت", field: "status" },
        { label: "نام و فامیل", field: "nameFamily" },
        { label: "کرایه کل به ریال", field: "rent" },
        { label: "کرایه پایه", field: "baseFare" },
        { label: "بیمه", field: "bime" },
        { label: "عوارض", field: "avarez" },
        { label: "کمیسیون شرکت", field: "commission" },
        { label: "شماره ملی", field: "driver.nationalId" },
        { label: "تاریخ", field: "created_at" },
        { label: "پلاک", field: "plaque" },
        { label: "نوع ماشین", field: "carTypeTitle" },
        { label: "نام شرکت", field: "company.company_name" },
      ],
    };
  },
  mounted() {

  },
  methods: {
    openBoxCancelRemittance(remittanceId){
      this.cancelRemittanceData.showBox = true
      this.cancelRemittanceData.remittanceId = remittanceId
    },
    printDialog(item){
      window.open('/print/Remittance/' + item.id);
    },
    getDriverDetail(id) {
      axiosApi().post('v2/admin/driver/detailDriver', {
        'driver_id': id
      }).then((result) => {
        this.driverData.data = result.data.data.driver
        this.driverData.data.created_at = getPersianDate(this.driverData.data.created_at)
        this.driverData.data.birthDate = convertDateOnly(this.driverData.data.birthDate)
        this.driverData.data.health_card_expire_date = convertDateOnly(this.driverData.data.health_card_expire_date)
        this.driverData.showBox = true
      })
    },
    changePaymentMethod(id){
      axiosApi().post('v2/admin/remittance/changePaymentMethod',{
        id : id
      }).then(()=>{
        Vue.$toast.open({
          type : 'success',
          message : 'توع پرداخت با موفقیت تغییر یافت'
        })
        this.updateTable()
      })
    },
    getRemittanceDetail(id){
      this.remittanceDetailData.data = ''
      this.remittanceDetailData.data = this.remittanceHistory.find(i => i.id === id)
      this.remittanceDetailData.showBox = true
    },
    paid(id){
      axiosApi().post('v2/admin/remittance/cardPaid',{
        id : id
      }).then(()=>{
        Vue.$toast.open({
          type : 'success',
          message : 'حواله به پرداخت شده تغییر یافت.'
        })
        this.updateTable()
      })
    },
    moving(id) {
      axiosApi()
        .post("v2/admin/remittance/moving", {
          id: id,
        })
        .then(() => {
          this.updateTable();
        });
    },
    arrivedToDestination(id){
      axiosApi().post('v2/admin/remittance/arrivedToDestination',{
        id : id
      }).then(()=>{
        this.updateTable()
      })
    },
    delivered(id){
      axiosApi().post('v2/admin/remittance/delivered',{
        id : id
      }).then(()=>{
        this.updateTable()
      })
    },
    cancelRemittance() {
      let data = {
        id: this.cancelRemittanceData.remittanceId,
      };

      if (this.cancelRemittanceData.turnActive) {
        data = {
          id: this.cancelRemittanceData.remittanceId,
          turn: "active",
        };
      }
      axiosApi()
        .post("v2/admin/remittance/cancelRemittance", data)
        .then(() => {
          this.cancelRemittanceData.showBox = false;
          Vue.$toast.open({
            message: "لغو حواله با موفقیت انجام شد",
            type: "success",
          });
          this.updateTable();
        });
      this.cancelRemittanceData.showBox = false;
      this.turnActive = null;
    },
    download() {
      fetch(this.showImageData.path)
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const link = document.getElementById("download-link");
          link.href = url;
          link.download = "عکس بارنامه";
          link.click();
          URL.revokeObjectURL(url);
        });
    },
    showImage(id) {
      axiosApi()
        .post("v2/admin/remittance/showWaybillImage", {
          remittanceHistory_id: id,
        })
        .then((result) => {
          this.showImageData.path = result.data.data.path;
          this.showImageData.showBox = true;
          let pdf = this.showImageData.path.search("pdf");
          if (pdf != "-1") {
            this.showImageData.isPdf = true;
          }
        });
    },
    updateTable(values) {
      this.$emit("updateTable", values);
    },
    resetDataObj(obj) {
      for (const key in obj) {
        if (typeof obj[key] == "boolean") {
          obj[key] = false;
        } else {
          obj[key] = "";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
